import axios from '@/axios.js'
import store from '../../store/index';
// import router from '../../router/index';

const actions = {
  addDebit({ commit }, value) {  
    axios.post('account/debits', value)
      .then(response => { 
        commit('SET_DEBIT', response.data.debit)    
        
        if(store.state.moduleDebit.errors !== null){
          commit('SET_ERRORS', null)  
        } 

      }).catch(error => {

        console.log(error)
        // commit('SET_ERRORS', error.response.data.errors) 
      })
  },

  getDebits({ commit }) { 
    return new Promise((resolve, reject) => {
      axios.get('account/debits')
      .then(res => { 
        // commit('SET_DEBITS', res.data.data) 
        resolve(res)
      }).catch(error => {
  
        console.log(error)
        // commit('SET_ERRORS', error.response.data.errors) 
      }) 
    })

  },

  findDebit(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`account/debits/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  editDebit({ commit }, value) {   
    axios.post('account/debits/' + value.id, value.data)
      .then(response => {
        commit('SET_DEBIT_UPDATED', response.data.debit)    
        
        if(store.state.moduleDebit.errors !== null){
          commit('SET_ERRORS', null)  
        } 
      
        // router.replace({ name: 'posts' });
  
      }).catch(error => { 
        // commit('SET_ERRORS', error.response.data.errors) 
      })
  },
  
  deleteDebit({ commit }, id) { 
    axios.delete('account/debits/' + id) 
      .then(res => { 
        commit('SET_DEBIT_DELETED', id) 
      }).catch(error => { 
        console.log(error)
      })
  }
}

export default actions